import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ size = 'md', showText = true, dark = false }) => {
  const sizes = {
    sm: { svg: 36, text: 'text-lg', tagline: 'text-[8px]', gap: 'gap-2' },
    md: { svg: 52, text: 'text-2xl', tagline: 'text-[9px]', gap: 'gap-3' },
    lg: { svg: 68, text: 'text-3xl', tagline: 'text-[10px]', gap: 'gap-3' },
    xl: { svg: 88, text: 'text-4xl', tagline: 'text-xs', gap: 'gap-4' }
  };

  const { svg, text, tagline, gap } = sizes[size] || sizes.md;
  const taglineColor = dark ? 'text-gray-300' : 'text-gray-400';

  return (
    <Link to="/" className={`flex items-center ${gap} no-underline`}>
      {/* Magnifying glass with "id" inside */}
      <svg viewBox="0 0 120 120" width={svg} height={svg}>
        {/* Magnifying glass circle — thin red ring */}
        <circle cx="52" cy="52" r="42" fill="none" stroke="#C41E23" strokeWidth="5"/>
        {/* Inner subtle fill */}
        <circle cx="52" cy="52" r="39" fill="#FDF5F5" opacity="0.6"/>

        {/* "id" text — dark navy with small grey accent square on the i */}
        <text x="24" y="68" fontFamily="'Inter', Arial, sans-serif" fontSize="48" fontWeight="700" fill="#1F2937" letterSpacing="-2">id</text>
        {/* Small accent square (tittle of the i) */}
        <rect x="28" y="28" width="7" height="7" rx="1" fill="#9CA3AF"/>

        {/* Magnifying glass handle */}
        <line x1="82" y1="82" x2="112" y2="112" stroke="#C41E23" strokeWidth="7" strokeLinecap="round"/>
      </svg>
      {showText && (
        <div className="flex flex-col">
          <div className={`font-bold ${text} leading-tight`}>
            <span style={{ color: '#1F2937' }}>id</span>
            <span style={{ color: '#C41E23' }}>100</span>
          </div>
          <span className={`${tagline} ${taglineColor} leading-tight tracking-[0.25em] uppercase font-medium`}>
            Due Diligence Platform
          </span>
        </div>
      )}
    </Link>
  );
};

export default Logo;
